import React from 'react'
import PageLayout from '../PageLayout'
import PatternsTable from './PatternsTable'

// const useStyles = makeStyles(theme => ({
//     content: {
//        //
//     },
// }))


export default function AppPatternsPage() {
    // const classes = useStyles()

    // console.log('AppPatternsPage render')

    return (
        <PageLayout>
            <PatternsTable />
        </PageLayout>
    )
}

